import { Button, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoginService from "../../services/loginService";
import BackdropLoaderService from "../../components/BackdropLoader/backdropLoaderService";
import NotificationService from "../../components/Notification/notificationService";
import settings from "../../config/settings";
import MenuService from "../../components/Menu/menuService";

const PasswordRecovery = () => {
  const navigate = useNavigate();
  const { code } = useParams();
  const [password, setPassword] = useState<string>("");
  const [passwordError, setPasswordError] = useState<boolean>(false);
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [confirmPasswordError, setConfirmPasswordError] =
    useState<boolean>(false);
  const { recoveryPassword } = LoginService();
  const { open: openBDL, close: closeBDL } = BackdropLoaderService();
  const { error, success } = NotificationService();
  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("password-recovery");
  }, []);

  const handleRecovery = () => {
    openBDL();
    if (formChecks() && code) {
      recoveryPassword(code, password, confirmPassword).then((result) => {
        if (result) {
          success("Password updated successfully");
          navigate(settings.homePage);
        } else {
          error("Password recovery failed");
        }
        closeBDL();
      });
    } else {
      closeBDL();
    }
  };

  const formChecks = () => {
    let valid = false;
    if (password !== "" && confirmPassword !== "") {
      if (!confirmPasswordError && !passwordError) {
        valid = true;
      }
    }

    return valid;
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        event.target.value
      )
    ) {
      setPasswordError(true);
    } else {
      setPasswordError(false);
    }
  };

  const handleConfirmPasswordChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setConfirmPassword(event.target.value);
  };

  const confirmPasswordCheckError = () => {
    setConfirmPasswordError(
      confirmPassword.length > 0 && confirmPassword !== password
    );
  };

  useEffect(() => {
    confirmPasswordCheckError();
  }, [confirmPassword]);

  const tfLabelProps = {
    sx: {
      color: "#6f7d95",
      fontSize: "1rem",
      fontWeight: 500,
      "&.MuiOutlinedInput-notchedOutline": {
        fontSize: "28px",
        border: "0px !important",
      },
    },
  };

  const tfInputProps = {
    disableUnderline: true,
    sx: {
      backgroundColor: "#f4f6f9",
      borderRadius: "3px",
      color: "#6f7d95",
      fontSize: "1rem",
      fontWeight: 500,
    },
  };

  return (
    <Grid container justifyContent={"center"} paddingTop={"14px"}>
      <Grid item container direction={"column"} xs={3}>
        <Grid item>
          <Typography variant="h2">Password Recovery</Typography>
        </Grid>
        <Grid item>
          <TextField
            InputLabelProps={tfLabelProps}
            InputProps={tfInputProps}
            sx={{ boxSizing: "border-box" }}
            required
            label="Password"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={handlePasswordChange}
            error={passwordError}
            helperText={
              "The password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)."
            }
          />
        </Grid>
        <Grid item>
          <TextField
            InputLabelProps={tfLabelProps}
            InputProps={tfInputProps}
            required
            label="Confirm Password"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            error={confirmPasswordError}
            sx={{ boxSizing: "border-box" }}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleRecovery}
          >
            Update password
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PasswordRecovery;
